import { useState, useEffect } from 'react';
import { miscGraphqlService } from '@/services/api/misc/miscGraphqlService';
import { useAuth } from '@/contexts/AuthContext';

export interface StateOption {
  id: number;
  state_name: string;
  state_code: string;
}

export const useStates = () => {
  const [states, setStates] = useState<StateOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { hasuraToken } = useAuth();

  useEffect(() => {
    const fetchStates = async () => {
      if (!hasuraToken) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        const data = await miscGraphqlService.getStates(hasuraToken);
        setStates(data);
      } catch (err) {
        console.error('Error fetching states:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch states');
      } finally {
        setIsLoading(false);
      }
    };

    fetchStates();
  }, [hasuraToken]);

  return { states, isLoading, error };
};
